import { IOwnedAlbum } from "../data_models/ialbum";
import { AGTranslator } from './ag_translator';
import { IPhoto } from '../data_models/iphoto';

/**
 * Responsible to translate all the User Assets Response Models to the Common model, which clients can understand. 
 * @export
 * @class UATranslator
 * @implements {ITranslator}
 */
export class LifeTouchIngTranslator {
    
    static getInstance(): LifeTouchIngTranslator {
      if (!LifeTouchIngTranslator.instance) {
        LifeTouchIngTranslator.instance = new LifeTouchIngTranslator();
      }
      return LifeTouchIngTranslator.instance;
    }
    private static instance: LifeTouchIngTranslator;
    /**
     *Method to get translate instagram photo to common format.
     *
     * @param {*} entity
     * @param {string} accountId
     * @returns {IPhoto}
     * @memberof InstagramIngTranslator
     */
    translateLifeTouchPhoto(entity: any,accountId:string): IPhoto {    

        const photo: any = {
            id: entity.uuid,            
            accountId: accountId,
            dataCenter: "AUS",
            name: "",
            size: 0,
            assetId: entity.id,
            url: entity.signedUrl,
            createDate: entity.captureDate,
            updateDate: entity.captureDate,
            dateTaken: entity.captureDate,
            lrHeight: entity.height || 200,
            lrWidth: entity.width || 200,
            landscape: entity.width >= entity.height ? true :false,
            assetSource: "lifetouch",
            reportingMediaSource: "lifetouch"
        }     
        return photo;
    }
    /**
     *Method to translate all the assest for the instagram cluster view to
     * common photo format.
     *
     * @memberof InstagramIngTranslator
     */
    translateLifeTouchClusterPhoto = function (entity: any, accountId: string):IPhoto {  
        var pasConvertedImage = LifeTouchIngTranslator.getInstance().translateLifeTouchPhoto(entity,accountId);
        var photo = AGTranslator.getInstance().translatePhoto(pasConvertedImage);
        return photo;
    }
    
  }